import { createFileRoute } from "@tanstack/react-router";
import AdminBusinessContinuity from "@/pages/AdminBusinessContinuity";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/business-continuity/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="Business Continuity"><AdminBusinessContinuity /></RoleGate>
  ),
});
